import { Map } from 'immutable';
import { TAAS_CONFIG } from '@constants/actions';

const initialState = Map({
  taasConfigList: [],
  selectedTaasConfig: {},
  activeTaasConfig: {},
});

const TaasConfig = (state = initialState, action) => {
  switch (action.type) {
    case TAAS_CONFIG.POPULATE:
      const taasConfigs = action.payload.taasConfigs;
      return state.set('taasConfigList', taasConfigs);
    case TAAS_CONFIG.SET_ACTIVE:
      const activeConfig = action.payload.activeConfig;
      return state.set('activeTaasConfig', activeConfig);
    case TAAS_CONFIG.SELECTED:
      const taasConfig = action.payload.taasConfig;
      return state.set('selectedTaasConfig', taasConfig);
    default:
      return state;
  }
};

export default TaasConfig;